import { Box, Theme, createStyles, makeStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router';

import { useBrandingContext } from '../../branding';
import IdentityConfirmationDeepLinkSuccess from './IdentityConfirmationDeepLinkSuccess';
import IdentityConfirmationDeepLinkValidation from './IdentityConfirmationDeepLinkValidation';
import Footer from '../../components/Footer/Footer';

function IdentityConfirmationDeepLink() {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { path } = useRouteMatch();
  const location = useLocation();
  const { logo: Logo } = useBrandingContext();

  const processingPath = `${path}/procesando`;
  const successPath = `${path}/exitosa`;

  const { token, userId } = useMemo(() => {
    const search = new URLSearchParams(location.search);
    const tk = search.get('token') ?? undefined;
    const uId = search.get('id') ?? undefined;
    return { token: tk, userId: uId };
  }, [ location ]);

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.header}>
        <Logo className={classes.logo} />
      </Box>
      <Switch>
        <Route path={processingPath}>
          <IdentityConfirmationDeepLinkValidation path={path} token={token} userId={userId} />
        </Route>
        <Route
          path={successPath}
          component={IdentityConfirmationDeepLinkSuccess}
        />

        <Redirect to={processingPath} />
      </Switch>
      <Box className={classes.footer}>
        <Box className={classes.footerCertification}>
          <Footer isIdValidation />
        </Box>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapper: {
    alignItems: 'center',
    background: 'linear-gradient(180deg, rgba(231, 253, 246, 0.80) 0%, rgba(235, 255, 242, 0.00) 100%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  header: {
    padding: theme.spacing(6.75, 10),
    width: '100%',
  },
  logo: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  footer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3.375, 10),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
    },
  },
  footerCertification: {
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
}));

export default IdentityConfirmationDeepLink;
